






import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { SelectionModeKinds } from "../../../domain/document";
import { HisInformationItem, HisInformationListItem } from "../../../domain/his";
import { HisItemParameter } from "../../../domain/his/behavior";
import { HisInformationListItemGroupSource, IHisInformationGroupSource } from "../../../domain/his/groupInput/HisInformationGroupSource";
import { UserDefinitionSelectResult } from "../../document/editor/dialogs";
import LightUserDefinitionDialog from "../../document/editor/dialogs/LightUserDefinitionDialog.vue";
import { IHisInfoSelectDialog } from "./IHisInfoSelectDialog";

@Component({
  components: {
    LightUserDefinitionDialog,
  },
})
export default class HisInfoInstitutionSelector extends Mixins() implements IHisInfoSelectDialog {
  @Prop()
  parameter: HisItemParameter;

  // 変わることないような気はする
  @Prop({ default: "MedicalInstution.csv" })
  fileName: string;

  async show(): Promise<IHisInformationGroupSource> {
    try {
      const isAvailable = await this.isAvailableUserDefinition();
      if (!isAvailable) {
        return null;
      }
      const result = await this.showuserDefinitionSelectDialog();
      if (!result) {
        // キャンセルしたとき
        return new HisInformationListItemGroupSource(undefined, "");
      }
      const text = this.createText(result);
      const item = new HisInformationItem(this.parameter.key, text);
      const listItem = new HisInformationListItem([item], []);
      return new HisInformationListItemGroupSource([listItem], "");
    } catch (e) {
      this.$error(
        "病院情報取得失敗",
        "病院情報を取得できませんでした。",
        e,
      );
      return null;
    }
  }

  async showuserDefinitionSelectDialog(): Promise<UserDefinitionSelectResult> {
    const dialog = this.$refs.selector as LightUserDefinitionDialog;
    return dialog.show(this.fileName, SelectionModeKinds.Row);
  }

  private async isAvailableUserDefinition(): Promise<boolean> {
    try {
      const repository = DomainRegistry.format.getFormatRepository();
      return await repository.isAvailableUserDefinition(this.fileName);
    } catch (e) {
      console.warn(e);
      return true;
    }
  }

  private createText(source: UserDefinitionSelectResult): string {
    if (!source || !source.items || source.items.length === 0 || !source.items[0].values || source.items[0].values.length === 0) { return ""; }
    // V1と同様に並び決め打ちでマッピングしている
    const hospitalName = source.items[1].values[0];
    const hospitalZipCode = this.convertZipCode(source.items[3].values[0]);
    const hospitalAddress = source.items[4].values[0];

    let telephoneNumber = "";
    let faxNumber = "";
    if (source.items.length >= 7) {
      telephoneNumber = source.items[5].values[0];
      faxNumber = source.items[6].values[0];
    }
    const additionalReturnText = this.isThreeLine() ? "\r\n" : " ";
    return hospitalName + "\r\n" + hospitalZipCode + " " + hospitalAddress + additionalReturnText + "TEL:" + telephoneNumber + " FAX:" + faxNumber;
  }

  /**
   * INTRO_HOSP_DESTINATION_PACKAGE  : 3行
   * INTRO_HOSP_DESTINATION_PACKAGE2 : 2行
   */
  private isThreeLine(): boolean {
    return this.parameter && this.parameter.key === "INTRO_HOSP_DESTINATION_PACKAGE";
  }

  private convertZipCode(source: string): string {
    if (!source || source.length < 4 || source[3] === "-") { return source; }
    return source.slice(0, 3) + "-" + source.slice(3);
  }
}
